import { useEditorState, type Editor } from '@tiptap/react';
export function useIsTableInactive(editor: Editor | null): boolean {
  return (
    useEditorState({
      editor,
      selector: (ctx) => {
        return !ctx.editor?.isActive('table');
      },
    }) ?? false
  );
}
